import { useEffect, useState } from "react";
import { useLoop } from "../loop-provider";
import { Drawer, Text, Image, Button, Form, Icons, useDrawer } from "../../design";
import { translate } from "../../utils/translations";
import SelectProductSubscriptionDrawer from "./select-product-subscription";
import {
    handleError,
    useAxios,
    getCurrencyDisplay,
    calcDiscountSpString,
    loopSAtoString,
    transformMultilingualDataForAddProducts,
    getCurrencyDisplayInternationalized,
    calcDiscountSpValue,
} from "../../utils/helpers";
import EditShippingAddressDrawer from "./create-subscription-edit-shipping-address";
import ChoseAddSubscriptionProductMethod from "./chose-add-subscription-product-method";
import CreateNewSubscriptionV2 from "./create-new-subscription-v2";

export default function CreateSubscriptionDrawerV2(props: any) {
    const drawers = useDrawer();
    const [axios] = useAxios();
    const { myshopify_domain, store, customer_shopify_id, localeRoute, locale, country, preferences } = useLoop();

    const [isLoading, setisLoading] = useState(false);

    const [selectedProduct, setselectedProduct] = useState(null);
    const [availableOptions, setavailableOptions] = useState([]);
    const [availableShippingAddresses, setavailableShippingAddresses] = useState([]);
    const [variantsDict, setvariantsDict] = useState({});

    const [selectedOptions, setselectedOptions]: Array<any> = useState([]);
    const [selectedVariant, setselectedVariant]: Array<any> = useState({});
    const [selectedSellingPlanId, setselectedSellingPlanId]: Array<any> = useState("");
    const [selectedSellingPlan, setselectedSellingPlan]: Array<any> = useState(null);
    const [selectedShippingAddressIndex, setselectedShippingAddressIndex]: Array<any> = useState(0);
    const [selectedProductPresetData, setSelectedProductPresetData]: Array<any> = useState(null);
    const [quantity, setquantity] = useState("1");

    const fetchPresetData = async (productShopifyId, myShopifyDomain) => {
        try {
            const LOOP_CDN_URL =
                process.env.NEXT_PUBLIC_ENV === "production"
                    ? "https://cdn.loopwork.co"
                    : "https://staging-cdn.loopwork.co";
            const baseUrl = `${LOOP_CDN_URL}/${myShopifyDomain}`;
            const presetUrl = `${baseUrl}/presetBundles/${productShopifyId}.json`;
            const presetRes = await fetch(presetUrl, {
                method: "GET",
                cache: "no-cache",
                mode: "cors",
                credentials: "same-origin",
                headers: {
                    Accept: "application/json",
                },
            });
            const productBundleData = await presetRes.json();
            return productBundleData;
        } catch (error) { }
    };

    const getVariantPresetData = async (variant: any) => {
        const productShopifyId = variant.product_shopify_id;
        const myShopifyDomain = myshopify_domain;
        const productBundleData = await fetchPresetData(productShopifyId, myShopifyDomain);
        if (productBundleData) {
            setSelectedProductPresetData(productBundleData);
        }
    };

    const getSelectedVariantSpPrice = (price) => {
        if (selectedProductPresetData) {
            const variants = selectedProductPresetData.variants;
            const variant = variants.find((v) => v.shopifyId === Number(selectedVariant.variant_shopify_id));
            if (variant) {
                const spPrices = variant.sellingPlanPrices;
                const sp = selectedVariant.selling_plans.find((sp) => sp.id == Number(selectedSellingPlanId));
                const shopifySpId = sp.shopify_id;
                const spPrice = spPrices[shopifySpId];
                return spPrice ?? price;
            } else {
                return price;
            }
        } else if (selectedVariant.selling_plans && selectedVariant.selling_plans.length > 0) {
            const sp = selectedVariant.selling_plans.find(sp => sp.id == Number(selectedSellingPlanId));
            if (sp) {
                return calcDiscountSpValue(
                    sp.pricing_policies,
                    0,
                    price,
                );
            } else {
                return calcDiscountSpValue(
                    selectedVariant.selling_plans[0].pricing_policies,
                    0,
                    price,
                );
            }
        }
        return price;
    }

    const loadProduct = async (product_shopify_id: any, isPresetProduct: any) => {
        setisLoading(true);
        try {
            const countryCode = (window as any)?.Shopify?.country || "__ALL__";
            let _params: any = {
                product_shopify_id: product_shopify_id,
                myshopify_domain: myshopify_domain,
                action: "create-subscription",
                countryCode: countryCode,
            };
            const [subscriptionData, storeDetails] = await Promise.all([
                axios.get(
                    `${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/read_subscription_variants_by_pid?` +
                    new URLSearchParams(_params),
                ),
                axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/store_details`),
            ]);

            const { data } = subscriptionData;
            const storeDefaultLocale: string = storeDetails?.data.data.default_locale;

            if (storeDefaultLocale != null && storeDefaultLocale != locale)
                await transformMultilingualDataForAddProducts(
                    data.data,
                    myshopify_domain,
                    localeRoute,
                    locale,
                    storeDefaultLocale,
                );
            setselectedProduct(data.data);

            let _variantsDict = {};
            for (let variant of data?.data?.variants || []) {
                _variantsDict[variant.variant_title] = variant;
            }
            setvariantsDict(_variantsDict);

            let _selectedOptions = [];
            for (let option of data.data.product_options) {
                _selectedOptions.push(option.values[0]);
            }
            setselectedOptions(_selectedOptions);

            if (data.data.variants_count > 1) {
                setavailableOptions(data.data.product_options);
            } else {
                setavailableOptions([]);
            }

            const _selectedVariant = _variantsDict[_selectedOptions.join(" / ")];

            setselectedVariant(_selectedVariant);
            if (isPresetProduct) {
                await getVariantPresetData(_selectedVariant);
            }
            setselectedSellingPlanId(`${_selectedVariant?.selling_plans[0]?.id || ""}`);
            setselectedSellingPlan(_selectedVariant?.selling_plans?.[0] || null);
        } catch (error) {
            handleError(error, "components/drawers/create-subscription", "loadProduct", { product_shopify_id });
        }
        setisLoading(false);
    };

    const handleProductSelect = async (product: any) => {
        drawers.close();
        await loadProduct(product.product_shopify_id, product.isPresetProduct);
    };

    const toggleProductSelect = () => {
        drawers.open({
            component: SelectProductSubscriptionDrawer,
            props: {
                handleProductSelect: handleProductSelect,
                hideBackButton: selectedProduct == null,
            },
        });
    };

    const handleOptionChange = (i: number, value: string) => {
        let _selectedOptions = selectedOptions.slice();
        _selectedOptions[i] = value;
        setselectedOptions(_selectedOptions);
        setselectedVariant(variantsDict[_selectedOptions.join(" / ")]);
        setselectedSellingPlanId(`${variantsDict[_selectedOptions.join(" / ")]?.selling_plans[0]?.id || ""}`);
        setselectedSellingPlan(variantsDict[_selectedOptions.join(" / ")]?.selling_plans?.[0] || null);
    };

    const handleShippingAddressEditConfirm = (address: any) => {
        let _availableShippingAddresses = availableShippingAddresses.slice();
        _availableShippingAddresses[selectedShippingAddressIndex] = {
            ...address,
        };
        setavailableShippingAddresses(_availableShippingAddresses);
    };

    const toggleEditShippingAddress = () => {
        drawers.open({
            component: EditShippingAddressDrawer,
            props: {
                shippingAddress: availableShippingAddresses[selectedShippingAddressIndex],
                handleConfirm: handleShippingAddressEditConfirm,
            },
        });
    };

    const findSubscriptionsForFreqAndDel = () => {
        const selectedShippingAddress = availableShippingAddresses[selectedShippingAddressIndex];
        const searchKey = `${selectedSellingPlan.billing_interval}${selectedSellingPlan.billing_interval_count}${selectedSellingPlan.billing_max_cycles}${selectedSellingPlan.delivery_interval}${selectedSellingPlan.delivery_interval_count}${selectedShippingAddress.zip}${selectedShippingAddress.province_code}${selectedShippingAddress.country_code}`;
        let _hash = {};
        for (let contract of props.activeContracts) {
            if (contract.isPrepaidV2) {
                continue;
            }
            let _key = "";
            _key += contract.billing_policy
                ? "" +
                contract.billing_policy.interval +
                "" +
                contract.billing_policy.interval_count +
                "" +
                contract.billing_policy.max_cycles
                : "";
            _key += contract.delivery_policy
                ? "" + contract.delivery_policy.interval + "" + contract.delivery_policy.interval_count
                : "";
            if (contract.shipping_address) {
                _key +=
                    contract.shipping_address.zip +
                    "" +
                    contract.shipping_address.province_code +
                    "" +
                    contract.shipping_address.country_code;
            }
            if (!(_key in _hash)) {
                _hash[_key] = {
                    billing_policy: { ...contract.billing_policy },
                    delivery_policy: { ...contract.delivery_policy },
                    shipping_address: { ...contract.shipping_address },
                    contracts: [],
                };
            }
            _hash[_key].contracts.push(contract);
        }
        return _hash[searchKey];
    };

    const handleConfirmNext = () => {
        const hasMapForContract = findSubscriptionsForFreqAndDel();
        const availableContacts = hasMapForContract?.contracts ?? [];
        if (availableContacts.length) {
            drawers.open({
                component: ChoseAddSubscriptionProductMethod,
                props: {
                    data: hasMapForContract,
                    selectedVariant,
                    quantity,
                    selectedSellingPlan,
                    availableShippingAddress: availableShippingAddresses[selectedShippingAddressIndex],
                    reloadContracts: props.reloadContracts,
                },
            });
        } else {
            drawers.open({
                component: CreateNewSubscriptionV2,
                props: {
                    selectedVariant: selectedVariant,
                    quantity: quantity,
                    selectedSellingPlan: selectedSellingPlan,
                    availableShippingAddress: availableShippingAddresses[selectedShippingAddressIndex],
                    reloadContracts: props.reloadContracts,
                },
            });
        }
    };

    const loadData = async () => {
        setisLoading(true);
        try {
            const [{ data: saData }] = await Promise.all([
                axios.get(`${process.env.NEXT_PUBLIC_LOOP_BACKEND}/api/customer/v2/available_shipping_addresses`),
            ]);
            if (saData.data.length > 0) {
                setavailableShippingAddresses(saData.data);
            } else {
                setavailableShippingAddresses([
                    {
                        first_name: "",
                        last_name: "",
                        company: "",
                        phone: "",
                        address1: "",
                        address2: "",
                        zip: "",
                        country_code: "",
                        province_code: "",
                        city: "",
                    },
                ]);
            }
            setselectedShippingAddressIndex(0);
        } catch (error) {
            handleError(error, "components/drawers/create-subscription", "loadData", {
                myshopify_domain,
                customer_shopify_id,
            });
        }
        setisLoading(false);
    };

    const isDataValid = () => {
        if (!selectedVariant) {
            return false;
        }
        if (!availableShippingAddresses[selectedShippingAddressIndex]) {
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (!selectedProduct) {
            toggleProductSelect();
        }
        loadData();
    }, []);

    return (
        <Drawer
            title={translate("select_product_drawer_header")}
            active={props.active}
            toggleActive={props.toggleActive}
            id="create-subscription-v2"
        >
            <Drawer.Body>
                {isLoading ? (
                    <Icons.Spinner />
                ) : (
                    <>
                        {selectedProduct ? (
                            <>
                                <div className="border-bottom pb-2">
                                    <Text.P1>{translate("subscription_create_product_title")}</Text.P1>
                                    <div className="d-flex my-3">
                                        <Image.ProductImage className="me-3" src={selectedProduct.image} />
                                        <div className="d-flex flex-column justify-content-between align-items-start">
                                            <div className="loop-cp-selected-product-title">
                                                <Text.P1>{selectedProduct.product_title}</Text.P1>
                                                <div className="d-flex align-items-baseline">
                                                    <Text.P2 className="loop-text-muted my-1">
                                                        {getCurrencyDisplayInternationalized(store.currency, locale, country, getSelectedVariantSpPrice(selectedVariant.price))}
                                                    </Text.P2>
                                                    <span className="text-decoration-line-through ms-2 loop-text-superscript">
                                                        {getCurrencyDisplayInternationalized(store.currency, locale, country, selectedVariant.price)}
                                                    </span>
                                                </div>
                                            </div>
                                            <Button size="sm" variant="underline" onClick={toggleProductSelect}>
                                                {translate("subscription_create_change_product_btn")}
                                            </Button>
                                        </div>
                                    </div>

                                    {availableOptions.length > 0 ? (
                                        <>
                                            <Text.P1>{translate("subscription_create_product_options")}</Text.P1>
                                            <div className="d-flex my-1">
                                                {availableOptions.map((option: any, i: number) => {
                                                    return (
                                                        <Form.Select
                                                            className="mt-1"
                                                            key={i}
                                                            label={option.name}
                                                            value={selectedOptions[i]}
                                                            onChange={(event: any) =>
                                                                handleOptionChange(i, event.target.value)
                                                            }
                                                            options={option.values.map((val: string) => {
                                                                return {
                                                                    label: val,
                                                                    value: val,
                                                                };
                                                            })}
                                                        />
                                                    );
                                                })}
                                            </div>
                                        </>
                                    ) : null}

                                    {selectedVariant ? (
                                        <>
                                            <div className="mt-3" style={{ maxWidth: "150px" }}>
                                                <Text.P1>{translate("subscription_create_quantity_label")}</Text.P1>
                                                <div className="d-flex my-2">
                                                    <Button
                                                        className="rounded-0 rounded-start d-flex align-items-center px-2 py-0"
                                                        variant="input"
                                                        disabled={parseInt(quantity) <= 1}
                                                        onClick={() => {
                                                            let _quantity = parseInt(quantity) - 1;
                                                            setquantity(_quantity + "");
                                                        }}
                                                    >
                                                        <Icons.Minus />
                                                    </Button>
                                                    <Form.Input
                                                        type="number"
                                                        className="rounded-0 border-start-0 border-end-0 text-center"
                                                        value={quantity}
                                                        onChange={(event: any) => {
                                                            setquantity(event.target.value);
                                                        }}
                                                    />
                                                    <Button
                                                        className="rounded-0 rounded-end d-flex align-items-center px-2 py-0"
                                                        variant="input"
                                                        onClick={() => {
                                                            let _quantity = parseInt(quantity) + 1;
                                                            setquantity(_quantity + "");
                                                        }}
                                                    >
                                                        <Icons.Plus />
                                                    </Button>
                                                </div>
                                            </div>
                                            {preferences.cp_prod_max_editable_quantity &&
                                                quantity > preferences.input_cp_prod_max_editable_quantity ? (
                                                <Text.P2 className="loop-text-muted loop-error-text">
                                                    {translate("max_quantity_update_error_message", {
                                                        maximum_allowed_quantity:
                                                            preferences.input_cp_prod_max_editable_quantity,
                                                    })}
                                                </Text.P2>
                                            ) : null}
                                        </>
                                    ) : null}
                                </div>
                                {selectedVariant ? (
                                    <>
                                        <div className="my-2">
                                            <Form.Select
                                                className="mt-1"
                                                label={translate("subscription_create_drawer_frequency_label")}
                                                value={selectedSellingPlanId}
                                                onChange={(event: any) => {
                                                    setselectedSellingPlanId(event.target.value);
                                                    setselectedSellingPlan(
                                                        selectedVariant.selling_plans.filter(
                                                            (item: any) => item.id.toString() == event.target.value,
                                                        )[0],
                                                    );
                                                }}
                                                options={selectedVariant.selling_plans.map((sp: any) => {
                                                    const _disc = calcDiscountSpString(
                                                        sp.pricing_policies,
                                                        0,
                                                        getCurrencyDisplay(store.currency),
                                                    );
                                                    let _discString = _disc
                                                        ? _disc.type == "PERCENTAGE" || _disc.type == "FIXED_AMOUNT"
                                                            ? _disc.value + " " + translate("off_label")
                                                            : "@ " + _disc.value
                                                        : null;
                                                    return {
                                                        label:
                                                            sp.loopSellingPlanGroupName +
                                                            " - " +
                                                            sp.name +
                                                            (_discString ? " (" + _discString + ")" : ""),
                                                        value: sp.id.toString(),
                                                    };
                                                })}
                                            />
                                        </div>
                                        <div className="my-2">
                                            <Form.Select
                                                className="mt-1"
                                                label={
                                                    <div className="d-flex justify-content-between">
                                                        <div className="loop-cp-subscription_create_drawer_shipping_address_label">
                                                            {translate(
                                                                "subscription_create_drawer_shipping_address_label",
                                                            )}
                                                        </div>
                                                        <Button
                                                            className="me-2"
                                                            variant="underline"
                                                            size="sm"
                                                            onClick={toggleEditShippingAddress}
                                                        >
                                                            {translate(
                                                                "subscription_create_drawer_edit_shipping_address_btn",
                                                            )}
                                                        </Button>
                                                    </div>
                                                }
                                                value={selectedShippingAddressIndex}
                                                onChange={(event: any) => {
                                                    setselectedShippingAddressIndex(event.target.value);
                                                }}
                                                options={availableShippingAddresses.map((sa: any, i: number) => {
                                                    return {
                                                        label: loopSAtoString(sa),
                                                        value: i,
                                                    };
                                                })}
                                            />
                                        </div>
                                    </>
                                ) : null}
                            </>
                        ) : null}
                    </>
                )}
            </Drawer.Body>
            <Drawer.Footer>
                <div className="d-flex flex-column">
                    <Button
                        size="lg"
                        className="m-2"
                        onClick={handleConfirmNext}
                        disabled={
                            !isDataValid() ||
                            isLoading ||
                            (preferences.cp_prod_max_editable_quantity &&
                                quantity > preferences.input_cp_prod_max_editable_quantity)
                        }
                    >
                        {translate("create_subscription_next_button_text")}
                    </Button>
                    <Button size="lg" variant="underline" className="m-2" onClick={props.toggleActive}>
                        {translate("subscription_create_drawer_close_btn")}
                    </Button>
                </div>
            </Drawer.Footer>
        </Drawer>
    );
}
